import { Responsive, WidthProvider } from "react-grid-layout";
import DashboardContainer from "routes/admin/DashboardContainer";

const ResponsiveReactGridLayout = WidthProvider(Responsive);

function AdminStatisticsManagement() {
  const indexes = [38, 39, 40, 68];
  const defaultLayout = {
    lg: [
      {
        w: 5,
        h: 11,
        x: 0,
        y: 0,
        i: "0",
        moved: false,
        static: false,
      },
      {
        w: 5,
        h: 11,
        x: 5,
        y: 0,
        i: "1",
        moved: false,
        static: false,
      },
      {
        w: 5,
        h: 11,
        x: 0,
        y: 11,
        i: "2",
        moved: false,
        static: false,
      },
      {
        w: 5,
        h: 11,
        x: 5,
        y: 11,
        i: "3",
        moved: false,
        static: false,
      },
    ],
    xs: [
      {
        w: 5,
        h: 11,
        x: 0,
        y: 0,
        i: "0",
        moved: false,
        static: false,
      },
      {
        w: 5,
        h: 11,
        x: 5,
        y: 0,
        i: "1",
        moved: false,
        static: false,
      },
      {
        w: 5,
        h: 11,
        x: 0,
        y: 11,
        i: "2",
        moved: false,
        static: false,
      },
      {
        w: 5,
        h: 10,
        x: 5,
        y: 11,
        i: "3",
        moved: false,
        static: false,
      },
    ],
  };

  return (
    <DashboardContainer
      name={"VendorStatistics"}
      indexes={indexes}
      defaultLayout={defaultLayout}
    />
  );
}

export default AdminStatisticsManagement;
